import * as z from 'zod';

import { governanceQuerySchema } from './governance-query-schema';

export const governanceMutationSchema = governanceQuerySchema
  .omit({
    supporting_documentation: true,
  })
  .extend({
    registered_agent_addresses: z.array(z.number()),
    supporting_documentation: z.array(z.number()),
  });

export type GovernanceMutationSchema = z.infer<typeof governanceMutationSchema>;

export const governanceCreateSchema = governanceMutationSchema.omit({
  id: true,
});

export type GovernanceCreateSchema = z.infer<typeof governanceCreateSchema>;
